export const defaultDatabase = [
  {
    label: '1,4-elimination',
    rxnCode:
      'gGP`@TfZj`OdHL@!eMHAIXH eMHAIXH#qnSa qnX qbH#!RbOvH@oy??`BH?Qwr_@ !R@Fp@DquZ_@ !R@Fp@Dqwz_@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 c.',
    kind: 'reaction',
    web: '',
    mode: 'both',
    isbn: '',
    ion: 'Unknown',
  },
  {
    label: '1,4-elimination',
    rxnCode:
      'diDD@@IIf]jjh@~HHJFch@!gGP`Ademj`Oih@ eM@HvB#IXjsaRX IXjxY Q^#!R?g~w?Xc}?g~w@h`Bm?vH?QuRG@ !Rb@JH?_y?b@JH?QvzO@ !R_qL@DqtFo@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 d.',
    kind: 'reaction',
    web: '',
    mode: 'both',
    isbn: '',
    ion: 'Unknown',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'gNyAFAJRjuU@_HX|@!gFxA@IReSZj`OhL@ fI@Gu`#q}NTX q\\jN qx#!R@Fp@DpAl@AL@[@@SGTi| !R?g~w@k_}m?vw@atzO@ !RGXY|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'gJYABAJRmTA|aap!gBXA@IReZj@~`p fI@Gu`#qNTh qlr qH#!R@Fp@DpAl@AL]bgp !R?g}??g?~G]j| !RGPY|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'gGYAJAJRkUPGrFW@!gKXA@IReqjhCzC@ fI@Gu`#qbqk q]Qp a`#!R@AL@[@@S@Fp@DquJo@ !R?g|_Fa}eTv\\]vcp !RGPY|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'gCiALAJRu@_HYl@!fI@Gu` eO``fNZ`~c@#qNT qH Qg#!R@AL@[@@SGPj| !RG]i| !R?g~w?Quzo@',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'eMH`eIXOda`!fI@Gu` eF@bXhP#Qy Qp Qd#!R@Fp@DqtJ_@ !RG]i| !R@AL]^gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'dazHBN@IRUUjj`Cy@sl@!gOxA@IReVnjj@~`p fI@Gu`#IEjKDc` q|ZnH ID#!R@AL@[@@S@Fp@DpAl@AL]rkp !R?g}GCD]sw}g_qfvOGSh| !RGXY|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Water elimination',
    rxnCode: 'eMHAIhOlba`!fI@Gu` eF@HhP#Qv Qp Qd#!R@Fp@XqvJ?@ !RG]i| !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 18 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Water elimination',
    rxnCode: 'eMHAIhOda`!fI@Gu` eF@HhP#Qv Qp Qd#!R@Fp@XqvJ_@ !RG]i| !R@FL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Tropylium resonance ',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#qgSuH qrLoX#!R?g}GCD]sw}g_qfvOGSH| !R?g}GCD]sw}g_qfvOGUh|',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Retro-heteroene (McLafferty-type rearrangement)',
    rxnCode:
      'gJQ@@dju@_Pp!eMHAIhOh` eF@HhP#qir` qip Qd#!R@Fp@DpAl@AL]Rgp !R@Fp@Dqtz_@ !R@AL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Retro-heteroene (Claisen rearrangement)',
    rxnCode:
      'daxH@@Revif`B!daxH@@RUiZjPB#IrBRfG` IrDZax`#!RmpJH@k_}bOvH@hc}?`@]|`H !R@AL@[@@S@Fql_qM?@AL]~cp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'daxDB@PIRYUZf``gZF|`QtQahXO}a`!gJQ@@djl`P eFH`fLGtX#qnQcG qnKx QX#!R?g~w?Xc}mpJH@k_}?`@]dep !R@AL@DpAl@AL]^cp !R@AL]agp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig. 13 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'daDLB@SdeIeVfZjh@~QHz@!gCaAAiRUhB gC``@dfi@~PaP#Izb[HPP IFDp q}K#!RbOvH?Oy?bOvH__y??g|]lnp !R@AL@[@@SG]j| !Rb@K~@Hc}GPZB',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 14 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Retro-ene',
    rxnCode:
      'gJQ@@eKS@_Pq~LT!eMHAIXH eF@HhP#qTuH qTh qq#!R_vp@[G|S@AL]|gp !R@Fp@Dqtz_@ !R@AL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.3',
    description: 'Fig. 11 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gOu@Dpdrm[TtA@!gJY@BDeUdB eF`BJD#IgBRhX IgDa` qM#!RbOvH?Oy?bOvH__y?GWI\\ !R@AL@DpAl@AL]Ncp !R@AL]Agp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 d.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gFx@@eJfuS@P!gC`@Die@` eF`BJD#q]aV qqU q\\#!R?g~w@k_}m?vw@auRO@ !R@Fq?[@@SGUk| !R@AL]^gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gFp@DiTujhB!gC`@Die@` eF@HhP#q]aV q]a Q\\#!R?g~w@k_}m?vw@auRO@ !R@Fq?[@@SGUk| !R@AL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'daDD@@QIe^fZfh@`!gGQ@@djlrHf eFHBJD#ItYyRhp It^Jc IeP#!RbOvH?Oy?bOvH__y?bOt]|ep !RbOw~_xc}b@JH?QvzW@ !R@AL]Agp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Resonance',
    rxnCode: 'eF``fJD!eF`bfLD#Qd Qd#!R@AL]bgp !R@AL]vkp',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://en.wikipedia.org/wiki/Oxonium_ion',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Resonance',
    rxnCode: 'eFB`HIba@!eFB`HicA@#Qd Qd#!R@AL]bgp !R@AL]vkp',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://en.wikipedia.org/wiki/Oxonium_ion',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode: 'eMH`eIXOh`!fH@Oj@ eFH`fND#Qv a` Qt#!R@Fp@Dqwr_@ !RGUi| !R@AL]ngp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '3',
    description: 'Fig. 4.1. b',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode: 'eMHAIhOda`!fI@Gu` eF@HhP#Qg a` Qt#!R@Fp@DqvJ_@ !RG]i| !R@AL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.1',
    description: 'Fig. 8 a. & b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Oxonium Resonance',
    rxnCode: 'eFH`fJGtP!eFHbfLGtP#QX QX#!R@AL]Rgp !R@AL]Nkp',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://en.wikipedia.org/wiki/Oxonium_ion',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eM`BN`~b|b`!eM``fN`~cP#Qg Qg#!R_qL@DqvJ_@ !R_qL@DqwZ_@',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eMHBN`~a|b`!eMH`fN`~bp#Qg Qg#!R_qL@DqvJ_@ !R_qL@DqwZ_@',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eMB@HchOh_Hh!eMB`HIchOhl#Qg Qg#!R_qL@DqvJ_@ !R_qL@DqwZ_@',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF`BLGt[dT!eF``fLFD@#Qd Qd#!R@AL]Rgp !R@AL]vop',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF`BJGtOdT!eF``fJGtV#Qd Qd#!R@AL]Rgp !R@AL]vgp',
    ionization: 'esi',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFHBLGtWdT!eFH`fLGtZ#Qd Qd#!R@AL]Rgp !R@AL]vgp',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFHBJGtOdT!eFH`fJGtV#Qd Qd#!R@AL]Rgp !R@AL]vgp',
    ionization: 'esi',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFBCDcArJ!eFBcDIcA}E`#QX QX#!R@AL]bgp !R@AL]vgp',
    ionization: 'esi',
    reaction: '',
    doi: '',
    section: '5',
    description: 'Fig. 10',
    kind: 'ionization',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFBBHcArJ!eFBbHIcA}E`#QX QX#!R@AL]bgp !R@AL]vgp',
    ionization: 'esi',
    reaction: '',
    doi: '',
    section: '5',
    description: 'Fig. 10',
    kind: 'ionization',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFB@HcA}EyE@!eFB`HIcA}F`#Qd Qd#!R@AL]Rgp !R@AL]vgp',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFB@Hba}CyE@!eFB`HIba}E`#Qd Qd#!R@AL]Rgp !R@AL]vgp',
    ionization: 'esi',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Inductive cleavages assisted by β-hydrogen removal',
    rxnCode:
      'dayHBDxDeIYujj@OdRJ`!gCi@DDeZ@~b` gChA@IRVdCzB@#IyjH\\R@ IyjD qbq#!Rb@JH?X`B?g~H?X`BbOt]Bkp !R@AL@[@@SGSi| !R@AL@[@@SGXY|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.4',
    description: 'Fig 23 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eMhdYRVCz\\@!fJ@D eFH`fND#Qg Qp Qd#!R@Fp@DqvJ_@ !RGUi| !R@AL]ngp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eM``fN`~c@!fHT`P eF`BLGtX#Qg QP Ql#!R_qL@Dqur_@ !RGYi| !R@AL]ngp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode:
      'eMJdBBTfP~b@!fH`PA@ eFH`fND#Qg a` Qt#!R@Fp@DqtJ_@ !RGYi| !R@AL]ngp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eMDaYRVCzX@!fI@D eFH`fND#Qg Qp Qd#!R@Fp@DqvJ_@ !RGUi| !R@AL]ngp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode:
      'gJXA@IczhC[QZNdLBa`tLG~zK@!fJ@Gup fHT`P#Q`D a` QP#!R?`C~_xc}m?t]|gp !RGUi| !RG[i|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eFH`fLGtX!fI@Gu` fHT`P#Qd a` QP#!R@AL]|gp !RGUi| !RG[i|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eFBcpIcA}G@!fHg`A}\\ fHT`P#Qd a` QP#!R@AL]|gp !RGUi| !RG[i|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Inductive cleavagea',
    rxnCode: 'eFB`HIcA}F@!fH`PA}X fHT`P#Qd a` QP#!R@AL]|gp !RGUi| !RG[i|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gCaA@IRmhCzZ@!eFH`fJGtP eF@HhP#qqT qq Qd#!R_vp@[@@SGPi| !R@AL]vgp !R@AL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.3.',
    description: 'Fig. 7.7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Hydrogen elimination',
    rxnCode:
      'gFpACJTj[KTA}C`!gFpAAJTjZ@@A@#qbqk qn\\J#!R?g~w@k_}m?vw@aurO@ !R?g~w@k_}m?vw@auZO@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Halide elimination',
    rxnCode: 'eFBcDIcA}D@!fHfHA}P fHT`P#QX QP a`#!R@AL]|gp !RGUi| !RG[i|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '5',
    description: 'Fig. 10',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Halide elimination',
    rxnCode: 'eFBbHIcA}D@!fHdPA}P fHT`P#Qd a` QP#!R@AL]|gp !RGUi| !RG[i|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '5',
    description: 'Fig. 10',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Grob-Wharton',
    rxnCode:
      'gNpaAQJSOMU@_HQX@!gCa@@duPGtD@ eMH`eIXOh`#qNWeX qNW qlX#!Rb@JH?_x@b@K~@Hc}G_JB !Rb@K~@Hc}G]hB !R@Fp@Dqwz_@',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.5',
    description: 'Fig. 24 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gJXA@IRmZ`OdHL@!eM`bfN`~b@ eF@HhP#qTqh Q^ qi#!R_qL@DpAl@AL]Bkp !R_qL@DqwZo@ !R@AL]Akp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gJPaAaJTkTHGyZC@!eMDaIRVCyHX@ eF@HhP#qbqh qbH qu#!RmpJH@ox@bOt]\\hH !R@Fp@Dqtz_@ !R@AL]Akp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gChA@Icu@_PP!fH@H eM``fM`~b@#qTq qH Q[#!Rm?w~@Hc}GWK| !RG[i| !R_qL@DquZ_@',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gChA@IRmhCzB@!eF``fJGtX eF@HhP#qTq QX qq#!R_vp@[@@SG_I| !R@AL]Vgp !R@AL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Displacement Reaction b.',
    rxnCode:
      'gJXA@IRUjPH!eM@fXvB eF`BLGtP#qlVH qrH ql#!R@Fp@DpAl@AL]Bgp !R_qL@DqwZO@ !R@AL]~gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Displacement Reaction b.',
    rxnCode:
      'gJQA@IRUjPH!eM@fXvB eFH`fLGtP#qbqh qNh Qd#!R@Fp@DpAl@AL]Bgp !R_qL@DquZO@ !R@AL]~gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Displacement Reaction b.',
    rxnCode:
      'gJPI@DBTeZdB!eM@fXvB eFB@HcA}D@#qbqh qNh Qd#!R@Fp@DpAl@AL]Bgp !R_qL@DqwZO@ !R@AL]~gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Displacement Reaction a.',
    rxnCode:
      'gGYADEJSLuPGtT_nlK|!gChA@Icu@_PP eFHBND#qtSi qQ] Qx#!RbOvH@oy??`BH?QtJo@ !Rm?w~@Hc}GUk| !R@AL]^gp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7.1.3',
    description: 'Fig. 22 c. ',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Cycloreversion',
    rxnCode:
      'gFp@DiTvjhB!eF@HhP eF@HhP eF@HhP#qcUq Qd qk qN#!R?g~w@k_}m?vw@avRO@ !R@AL]Fkp !R@AL]Nkp !R@AL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 17 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+H]+',
  },
  {
    label: 'Cleavage Bond Adjacent heteroatom with cyclisation',
    rxnCode:
      'gNuADpyRUUjhB!gFyALAJTjZuTA@ fJ@D#q|VMX q|jN qX#!R@Fp@DpAl@AL@[@@SG\\i| !R?g~w@k_}m?vw@awZw@ !RGPY|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M+H]+',
  },
  {
    label: 'Retro-heteroene (McLafferty-type rearrangement)',
    rxnCode:
      'gNpiIahRTeVfj@~ec|x@!gC`iIahRTef@~fc|x@ eM@HvB#qbqkx qar qkx#!R@O{DTlPmqEK~jLPmG_JB !R@O{DTlPmG[i| !R_qL@DqvFo@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+Na]+',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'gGP`@TeYjPOhX@!eMHAIdOh` eMHAITH#qirc qip qbX#!Rb@JH?X`B?`BH?QtJ`` !R@Fp@DqwZ_@ !R_?y??auz_@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 14 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+Na]+',
  },
  {
    label: 'Aromatic elimination',
    rxnCode:
      'ded@@DiUUeiZ@hTZfh!gFp@DiTt@@B gC`@DiZDC@#IpdjFGiT qcUq IGiT#!RbGvw_X`B?g?~@K]}b@K~_?x@GWJ| !R?g~w@k_}m?vw@avZO@ !Rb@K~_xc}GPZ|',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.6',
    description: 'Fig. 16',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M+Na]+',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'gGQa@bnR[fj@~a`!gJPa@erS[RA@ fI@Gu`#qrLk qrLX qh#!RbOw~_x`B?`BH?Qwro@ !RbOw~_x`BbOt]vmp !RG_i|',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '2',
    description: 'Fig. 3',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'gGP`@df]j`OiX@!gC``@dfZ@~b` eF@HhP#qYnb qYn Qd#!Rb@JH?_x@b@JH?QuJ@` !Rb@K~@Hc}GSjB !R@AL]Akp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 14 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Retro-ene',
    rxnCode:
      'gJQ@@dkT`_PQ~zSOp!eM@HvB eFHBJD#qiTp Qg qi#!R@Fp@DpAl@AL]bop !R_qL@DquZo@ !R@AL]~gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.3',
    description: 'Fig. 11 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gFq@@eJftu@P!gCa@@dkHD eF@HhP#qi^b qir qc#!R?g~w@k_}m?vw@auRO@ !R@AL@[@@SG]i| !R@AL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 d. & Fig 10 e.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode:
      'gCa@@eMPD!eFHBLGtP eF@HhP#qTq Q\\ qa#!R@Fq?[@@SG_I| !R@AL]Vgp !R@AL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.1',
    description: 'Fig. 8 c.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Ionization',
    rxnCode: 'fH`PA}[eP!fHpPxCzl#a` a`#!RGRi| !RGUi|',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Ionization',
    rxnCode: 'eM`BN`~b|b`!eM``zN`~ap#Qg Qg#!R_qL@DqvJ_@ !R_qL@DqwZ_@',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF`BLGt[dT!eF``zLGtV#Qd Qd#!R@AL]Rgp !R@AL]vgp',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFJH|Hp_U_~UP!eFJh|Khp_Tx#QX QX#!R@AL]rkp !R@AL]Nkp',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFHBLGtWdT!eFH`zLGtN#Qd Qd#!R@AL]Rgp !R@AL]vgp',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFB@HcA}EyE@!eFB`HNcA}C`#Qd Qd#!R@AL]Rgp !R@AL]vgp',
    ionization: 'esi',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Eliminations assisted by β-hydrogen removal',
    rxnCode:
      'dctJbHSNdOCNrRSEISMUTt@[PTXIF@PvB@!gNpYHlqxOdj}Zj@~f` gCa@@djpD#IeQtNZlIH IeQwfh qNT#!R?[^H?[\\B@hbH@hc}b@JH?_y?b@JH?Qvro@ !RmpJH@oy?bOvH@hc}G[j| !R_?y??ovwGXZ|',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2.4',
    description: 'Fig. 29',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Displacement Reaction a.',
    rxnCode:
      'dctJB@SaT^RYyWfjjf@H!gC`a@erSM@P daDL@@Sdf^Vyjj`B#IMTwBFi[h q{l IMTwBFP#!RbOvH@oy?bOvH@oy?bOvw?X`B?`BH?QtJO@ !Rb@K~@Hc}G]jB !RbOvH@oy?bOt`^gi_^e|]Qmp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 28 c.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Displacement Reaction a.',
    rxnCode:
      'dctFbHSBEP|ByJk_mZjjh@~`X@!eFHBLGtP deTJbHSBdOB^rRSIHlKUUT@P#ISBbfOae] IWP ISJJIX~D#!R?K^H?K_|?[^H?[_}bOs~@Hc}bOrH?Qur?@ !R@AL]vgp !Rm?vH?Oy?mpJH?Xa}m?w~_xc}GPX|',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 28 b.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Displacement Reaction a.',
    rxnCode:
      'dcLFbHSBEP|ByJk_Vifjjf`B!gC`a@erSM@P dadB`HSBCpRjuijyjjh@`#IIjshPYWS IuYL IIjshPP#!Rs|uTa@JwYrsPs\\Bfb@JH?X`B?`BH?QtJ@` !Rb@K~@Hc}GSjB !RbOu?x_h`Ou}udE_\\U}p]Agp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 28 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'CO elimination',
    rxnCode:
      'gOp`@tfUkZj`MYd@!gKQ@@eKcUPD eFHPfzND#q~JlX q\\jH q~#!RbOvH?Oy?bOvH__y?GPi\\ !R?g|_Fa}eTv\\]fcp !R@AL]^kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.8',
    description: 'Fig. 19',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: '1,4-elimination',
    rxnCode:
      'gGP@Divj`OdHL@!eM@HvB eM@HvB#qVak qiX Q^#!R@Fq?[@@S@Fp@DqtJ?@ !R_qL@DqwZo@ !R_qL@Dqwzo@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: '1,3-elimination',
    rxnCode:
      'gJQ@@dsU@_HPX@!eMHAIXH eF@HhP#qJth qJ` qu#!RbOvH@oy?bOt]bmp !R@Fp@Dqtz_@ !R@AL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 b.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'ζ-elimination',
    rxnCode:
      'dedDB@f^RYU^ejXLRrz~`H@!fH@Oj@ diDDB@D^RYWVefALfh#!R?g~w?Xc}mpK~_{_}bOvw@k_}G\\H\\ !RGTY| !R?g~H?[_}b@Jw@hc}b@JH?Quzw@#!R?g~H?[_}b@K~_xc}m?vH@hc}G]H\\ !RGYi| !R?g~H?[_}b@Jw@hc}b@JH?QvFw@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 27 d.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'γ-elimination ',
    rxnCode:
      'gNqa@f~RY]jXPl!gJP`@TeUdB eFHBLD#qiZ|p qiTp q_#!R?g~w?Xc}mpJH@ox@G]K\\ !R@AL@DpAl@AL]ncp !R@AL]Agp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 27 c.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'α-elimination',
    rxnCode:
      'gJPa@SrRkTA@!eMH`yIdH eFHBJD#qJuX qJp q]#!R@Fp@DpAl@AL]bgp !R@Fp@DqwZ_@ !R@AL]~gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 26 ',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'α-elimination',
    rxnCode:
      'gC`a@erSM@_SP!fHW@P eMDARUB#qbq qH Qg#!Rb@K~@Hc}GPjB !RGYi| !R_?y??atz_@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 25 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'α-elimination',
    rxnCode:
      'dedLB@RTyImUVjj`CzI`!gNq@`N_IJkUTA@ eMDARUB#IfESBinD IGfhlP IfE#!Rb@K~@Hc}b@JH?X`BbOvH@hc}GPjB !R@Fp@DpAl@AL@[@@SG_i| !R_?y??auF_@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 25 b.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'α-elimination',
    rxnCode:
      'daxDB@HnrJJHmSHA@!eMHAITH eM@ghvB eFHBND#IxjqaR@ IZa Q[ qy#!R?g~w?Xc}mpK~_x`BbOt]Dip !R_?y??awj_@ !R_qL@DquzO@ !R@AL]agp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 27 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'α-elimination',
    rxnCode:
      'daDHB@KdimVz`@@B!gFpAKrTjZ@@A@ eFHBJD#IzaIla@ qrLk IxP#!Rm?vH?_y?mpJw?[_}mpH]Tep !R?g~w@k_}m?vw@avZO@ !R@AL]~gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 25 c.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'α-elimination',
    rxnCode:
      'daDDB@HnRYg[fij@H!gFqAAnRYSVj`H eFHBND#IDjsfR@ IDlYH q}#!RbOvH?Oy??`BH?Xa}?g|]|kp !RBOuPtdy?UGm@VQwZw@ !R@AL]~gp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.2',
    description: 'Fig. 27 b.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M-H]-',
  },
  {
    label: 'Tropylium resonance',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#IaLkit I{MbTh#!R?g}GCD]sw}g_qfvOGSH| !R?g}GCD]sw}g_qfvOGUh|',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Tropylium resonance',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#q]yfP qgSuH#!R?g}GCD]sw}g_qfvOGSH| !R?g}GCD]sw}g_qfvOGUh|',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Tropylium resonance',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#qrLoX qMsW`#!R?g}GCD]sw}g_qfvOGSH| !R?g}GCD]sw}g_qfvOGUh|',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Tropylium resonance',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#qMsW` q{eQp#!R?g}GCD]sw}g_qfvOGSH| !R?g}GCD]sw}g_qfvOGUh|',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Tropylium resonance',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#q{eQp qTwKh#!R?g}GCD]sw}g_qfvOGSH| !R?g}GCD]sw}g_qfvOGUh|',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Tropylium resonance',
    rxnCode:
      'gOpAGJTju`@@D!gOpAGJTju`@@D#qTwKh qqUcx#!R?g}GCD]sw}g_qfvOGSH| !R?g}GCD]sw}g_qfvOGUh|',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/capture2867284230232943485.jpg',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Tropylium rearragement',
    rxnCode:
      'gOpAMJUKua@@D!gOpAGJTju`@@D#qgVMX qYoTp#!Rm?w~@Hc}mpJw@ox@G_K| !R?g}GCD]sw}g_qfvOGUh|',
    ionization: 'esi',
    reaction: 'Rearrangement',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M]+',
  },
  {
    label: 'Sigmatropic rearrangement',
    rxnCode: 'eM@HvCzX@!eM@HvB#Q^ Q[#!R_qL@DquJO@ !R_qL@Dqtzo@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 18 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'gGY@DDf]j`Odkl@!gCi@DDff@~`l eF@HhP#qrLk qrL qk#!Rb@JH?_x@b@JH?QuJ@` !Rb@K~@Hc}GSjB !R@AL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig. 13 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'fdeA`D@\\brTfYY_m]gIZ|EhJB@@h@@~aF@!didHB@BTfUvfZVV@OhB@ didD@@iIYgxUie`B#iup`jXdibCPcXKoI iSxKhvMHP IwbkEYH#!RbGvH?Oy?bGw~@Ha}?g~H?Hc|?g?~@Ha}mww~_?y?m?w~_quRS@ !RbOvH?Oy?bOvH__y?bOvH_QwZg@ !Rm?vw?_y?mpJH?[_}m?vw@auzG@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'dmLDB@{irJJIQEneV`hB@B!eF@HhP didDB@hIRVY~G``@@`#IwlDdeZa` IFP IwlIEjF#!RbGvH?Oy?bGw~@Ha}?g~H?Hc|?`@]|kp !R@AL]fkp !Rm?vw?_y?mpJH?[_}m?vw@atzG@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'dclDB@{iRYeevz]ZA`b@CzN`!gGPa@QJRmsPbX gFp@DiTt@@B#IwbFleVPx IwaeS qb^i#!RbGvH?Oy?bGw~@Ha}?g~H?Hc|?g?~@Aurw@ !RbOvH?X`B?`BH?Qtz_@ !R?g~w@k_}m?vw@awzO@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Remote hydrogen rearrangement',
    rxnCode:
      'diD@b@|@gIIETjji@NlRrJ}DP!gGPIAxBTjfjPH eM@HvB#IZnFRqH IZagb Q^#!R@AMl@G}lDw|@[@@S@Fp@Dqwr_@ !R@FpS@G|S[G|@Dqtz_@ !R_qL@DqtFo@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode:
      'dcN@B@J\\bRbRaWCUUUL@_ITC@!gFpAEJTjZuRA@ eM`AIhH eM@HvB#IO^adkBFU qb^i IO^ IeQ#!RbGvH@ha}bOs~_xa}bGw~_xc|?`BH?Awro@ !R?g~w@k_}m?vw@atZo@ !R@Fp@Dqwz_@ !R_qL@DqvFo@',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.1',
    description: 'Fig. 8 d.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Inductive cleavages assisted by β-hydrogen removal',
    rxnCode:
      'gFqAAYRe|Zj`OiH@!gGQA@IRezY@~``#qbqk qbqk#!R_O@T~pAYDEKp@qtJ_@ !R_qL@Dw}l@Fp@Dqtz_@',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.4 ',
    description: 'Fig 23 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Inductive cleavages assisted by β-hydrogen removal',
    rxnCode:
      'daxHB@zTeVVjh@~ah@!gGQA@IRUVi@~`` eF@HhP#IaLJnXP qbqk IxP#!Rb@JH?X`BbOvH@oy?bOt]Bcp !R@AL@[@@S@Fp@Dquz_@ !R@AL]akp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.4 ',
    description: 'Fig 23 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gGYALMJT}TpGRdX!gJY@DDefXB fHT`P#qnZa qnTH qX#!RbOvw?X`B?`BH?Qur?@ !RbOvH@ox@bOt]Nop !RG_i|',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'diD@b@|@gIIETjji@NlRrJ@!gC`HAxQz`H eM@fXvB eF@HhP#IaLJfxY qan IF^ qS#!R@AMl@G}lDw|@[@@S@Fp@Dqvr_@ !Rm?w~@Hc}GYk| !R_qL@DquzO@ !R@AL]akp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'dazHBLCIRfVjY`CiBfoQT@!gGYADEJSLtpD eF@HhP#IqBZJG` IqF`^ qM#!RbOvw?X`B?g~w@ox@bOt]lkp !RbOvH@oy??`BH?Qvzo@ !R@AL]Akp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Grob-Wharton',
    rxnCode:
      'gNxaLJIRU[jXCzZ@!eMH`eIxH eF`BJGtP eFHBND#q{iV` Qv qM q{#!R?g?~_xc}b@K~@Hc}G]H\\ !R_?y??auj_@ !R@AL]ngp !R@AL]Agp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.5',
    description: 'Fig. 24 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Cycloreversion',
    rxnCode:
      'gFpAAJTj[UTA@!eF@bXhP eF@HhP eF@HhP#q\\jN q] qN Qd#!R?g~w@k_}m?vw@avRO@ !R@AL]Fgp !R@AL]Nkp !R@AL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 17 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'CO Elimination',
    rxnCode:
      'gCaA@IRWhCZZLtLG~s@!fHT`P eFHPfzND#Qg@ Qp Qd#!R?g?~_xc}G_H\\ !RGYi| !R@AL]nkp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'MassFrontier, need to find literature',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Benzyl carbocation Resonance',
    rxnCode:
      'gOpAMJUNusMHD!gOpAMJUKua@@D#qi{tP qkOfP#!Rm?vH?_x@mpJw@ox@GWHB !Rm?w~@Hc}mpJw@ox@G]k|',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/1123794039966492669191.png',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Benzyl carbocation Resonance',
    rxnCode:
      'gOpAMJUNusMHD!gOpAGJUKutkPD#qkyfP qkOfP#!Rm?vH?_x@mpJw@ox@GWHB !Rm?w~@Hc}mpJw@ox@G]hB',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/1123794039966492669191.png',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'Benzyl carbocation Resonance',
    rxnCode:
      'gOpAGJUKutkPD!gOpAMJUNusMHD#qkOfP qi{tP#!Rm?w~@Hc}mpJw@ox@GWHB !Rm?vH?_x@mpJw@ox@G]hB',
    ionization: 'esi',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'resonance',
    web: 'https://homework.study.com/cimages/multimages/16/1123794039966492669191.png',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
  {
    label: 'McLafferty rearrangement',
    rxnCode:
      'gGP`@df]jPOiX@!gC``@dfZ@~bl eF@HxP#qrLk qJt qk#!Rb@JH?_x@b@JH?QuJ@` !Rb@K~@Hc}GSjB !R@AL]~kp',
    ionization: 'esi',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 30',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M]-',
  },
  {
    label: 'McLafferty rearrangement',
    rxnCode:
      'dctFbHSBEP|B{IILTdhuTtpPs}Fp!gOp`AdiekjV`H gJPYHlQxGh}j@~bl#I`tu\\JfxY I[jFRp IaEtp#!R?[^H?[\\B@hbH@hc}b@K~@H`BbOw~@AtJ`` !R?g~w@k_}bOvw?[\\BG]k\\ !Rm?w~@Oy?bOt]Agp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 30',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M]-',
  },
  {
    label: 'Radical fragmentation',
    rxnCode:
      'eMHBN`yE@!fH@O}R eFHBLG~hP#Qg Qp Qd#!R_qL@Dqur_@ !RGYi| !R@AL]ngp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.9',
    description: 'Fig. 20 a./ Fig. 21',
    kind: 'reaction',
    web: '',
    mode: 'both',
    isbn: '',
    ion: '[M]-/[M+H]+',
  },
  {
    label: 'Radical fragmentation',
    rxnCode: 'eMHBN`uR!eMHAIXH#Qg Qg#!R_qL@DqtJo@ !R@Fp@Dqtz_@',
    ionization: 'ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.9',
    description: 'Fig. 20 b.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M]-',
  },
  {
    label: 'Radical fragmentation',
    rxnCode:
      'didH@@RYWZZ@BP@u@H!didH@@RYWZYiYh@u@h#I{DJJXY I{DJJXY#!Rb@K~@Hc}b@JH@hc}b@JH?QvJ`` !Rb@K~@Hc}b@JH@hc}b@JH?Qwz``',
    ionization: 'ei',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.9',
    description: 'Fig. 20 a.',
    kind: 'reaction',
    web: '',
    mode: 'negative',
    isbn: '',
    ion: '[M]-',
  },
  {
    label: 'Remote Hydrogen Rearrangment',
    rxnCode:
      'gJQA@IRUZ`OhXjA@!gJQA@IRUZ`OhHjE@#qir` qir`#!R@Fp@DpAl@AL]Rgp !R@Fp@DpAl@AL]~gp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '4',
    description: 'Fig. 4',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'σ-cleavage',
    rxnCode: 'eF@Hp_|RuuB!fHT`P fH@O}R#Qd a` QP#!R@FL]Bkp !RGYi| !RG[i|',
    ionization: 'ei',
    reaction: '',
    doi: '',
    section: '7.4.1.1.',
    description: 'Fig. 7.6',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M]+*',
  },
  {
    label: 'Cleavage Bond Adjacent heteroatom',
    rxnCode:
      'gJQA@IRUZ`OdHL_u@`!eMHAIdOh` eF@bXp_zi@#qbqh Qg qi#!R@Fp@DpAl@AL]bgp !R@Fp@Dqtz_@ !R@AL]~kp',
    ionization: 'ei',
    reaction: 'CMF',
    doi: '',
    section: '7.4.2.',
    description: 'Fig. 11',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M]+*',
  },
  {
    label: 'Cleavage Bond Adjacent heteroatom',
    rxnCode:
      'gCaA@IRfhCTB!fH@O}R eMH`fM``#qVa qH Q^#!R@Fq?[@@SG_I| !RGWi| !R_qL@DquZ_@',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.3.',
    description: 'Fig. 7.7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M]+*',
  },
  {
    label: 'Cleavage Bond Adjacent heteroatom',
    rxnCode:
      'eMH`fN`uB!fHT`P eFHBLG~hP#Q[ Qp QX#!R_qL@Dqur_@ !RGYi| !R@AL]ngp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.3.',
    description: 'Fig 7.7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M]+*',
  },
  {
    label: 'Cleavage Bond Adjacent heteroatom',
    rxnCode: 'eFB`HIcA}D_uB!fH`PA}QT` fHT`P#QX QP a`#!R@AL]|gp !RGUi| !RG[i|',
    ionization: 'ei',
    reaction: 'CMF',
    doi: '',
    section: '7.4.1.5.',
    description: 'Fig. 7.10',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M]+*',
  },
  {
    label: 'Cleavage Bond Adjacent heteroatom',
    rxnCode: 'eF@bXp_za@!fHT`P fH@O}R#Qd QP a`#!R@AL]|gp !RGYi| !RGSi|',
    ionization: 'ei',
    reaction: 'CMF',
    doi: '',
    section: '7.4.1.1.',
    description: 'Fig. 7.6',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage (cyclic)',
    rxnCode:
      'gFpAAJTj[UTAjQ@!gC`AEJUm@_zfP eF@HhP#qi^b qNk Qd#!R?g~w@k_}m?vw@auRO@ !R_vp@[@@SGUhB !R@AL]^kp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '2',
    description: 'Fig. 2',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gJXA@IRij`O}PH!gChA@Icm@P fH@O}R#qrM` qrM a`#!Rb@Jw@oy?bOt]|kp !Rm?w~@Hc}GUk| !RGWi|',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gJXA@IRij`O}PH!gChA@Icm@P fH@O}R#qrM` qrM a`#!Rb@Jw@oy?bOt]|kp !Rm?w~@Hc}GUk| !RGWi|',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gJQA@IRUZ`OdHL_u@`!eMHbeIhOhc~iP eF@HhP#qir` qip Qd#!R@Fp@DpAl@AL]Rgp !R@Fp@Dqvz?@ !R@AL]Akp',
    ionization: 'ei',
    reaction: 'CMF',
    doi: '',
    section: '7.4.2.',
    description: 'Fig. 11',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gJPa@aJSKTAjA@!gC`a@aJR}@P fH@O}R#qjtH qjq a`#!RbOvH@oy?bOt]bcp !R?g?~_xc}G]j\\ !RGWi|',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gJPAAJT}TA}CG}QH!eM@bXzCUH eF@HhP#qNj` qNh Qd#!R@AM?DpAl@AL]Bkp !R_qL@DqwZo@ !R@AL]~kp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 9',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gGXA@IRgVjDE}KG}PH!gChA@IRehPWtD_uL` eF@HhP#qi^T qi^ Qd#!R@Fq?[@@S@Fp@DqvJ_@ !R@Fq?[@@SGSi| !R@AL]Akp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 9',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gGQA@IRYvj@~ec~hD!gCaA@IRYhCzBOzbP eF@HhP#qisT qis Qd#!Rb@JH?_x@b@JH?QvJ@` !Rb@K~@Hc}GSjB !R@AL]Akp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 9',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gGPa@eJSNuPG~hd!gJPaAaJTtlA@ fH@O}R#qrLk qJn` qX#!Rb@JH?_x@b@JH?QvJ@` !Rb@Jw@ox@bOt]vhH !RG_i|',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gGPAIJUKUPGQEKQoz`P!gJPAEJU[TA@ fH@O}R#qTis qUap qX#!RmpJH@oy?m?vH?Qtro@ !RmpJH@oy?bOt]vgp !RG_i|',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gCaA@IRfhCTB!fH@O}R eMH`fM``#qrL a` qrH#!R@Fq?[@@SG_I| !RGYi| !R_qL@Dqvz_@',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gCaA@IRYhCTB!fH@O}R eMH`eIxH#qra a` qrH#!Rb@K~@Hc}G_HB !RGQi| !R_?y??atz_@',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gCaA@IRYhCTB!fH@O}R eMH`eIxH#qra a` qrH#!Rb@K~@Hc}G_HB !RGQi| !R_?y??atz_@',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'gC`AEJTu@_z`P!fH@O}R eM@fXvB#qrL a` qrH#!R@Fq?[@@SGWK| !RGYi| !R_qL@DquzO@',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 8',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'eM``eIhO}PqFp!fH@O}R eF``fJGtX#Q[ Qp QX#!R@Fp@Dqwr_@ !RGYi| !R@AL]ngp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.3.',
    description: 'Fig. 7.7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'eMH`eIhOho~hP!fH@O}R eFH`fJGtP#Qv a` Qt#!R@Fp@Dqwr_@ !RGYi| !R@AL]ngp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '1',
    description: 'Fig. 1<NL>',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'eMH`eIXO}P`!fH@O}R eFH`fND#Q[ Qp QX#!R@Fp@DqtJ_@ !RGYi| !R@AL]ngp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.5.',
    description: 'Fig. 11',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'eMB`HIchO}P`!fH@O}R eFB`HIba}D@#Q[ Qp QX#!R_qL@Dqur_@ !RGYi| !R@AL]ngp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.4.',
    description: 'Fig 7.9',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'eMB`HIRZCzHjD!fH@O}R eFB`HIba}D@#Q[ Qp QX#!R@Fp@DqtJ_@ !RGYi| !R@AL]ngp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.5.',
    description: 'Fig. 7.10',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
    ion: '[M]+*',
  },
  {
    label: 'α-cleavage',
    rxnCode:
      'did@BBeJU]JiZj`CzAc~hi@!gOpACJTjfruPG~ht eF@HhP#IJlYHxY qMsTx IdP#!R?`BH?X`Bb@JH?Xc}b@JH?QuJ?@ !R?`BH_Xc|b@JH?Xc}G[hB !R@AL]Akp',
    ionization: 'ei',
    reaction: 'CRF',
    doi: '',
    section: '5',
    description: 'Fig. 9',
    kind: 'reaction',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
    ion: '[M]+*',
  },
  {
    label: 'Ionization',
    rxnCode:
      'eM`BN`~b|b`!fH@O}R eF``fLGtWTH#Qg Qp Qd#!R_qL@Dqwr_@ !RGYi| !R@AL]ngp',
    ionization: 'ei',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]*+',
  },
  {
    label: 'Ionization',
    rxnCode:
      'eMHBN`~a|b`!fH@O}R eFH`fLGtOTH#Qg Qp Qd#!R_qL@Dqwr_@ !RGYi| !R@AL]ngp',
    ionization: 'ei',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]*+',
  },
  {
    label: 'Ionization',
    rxnCode:
      'eMB@HchOh_Hh!fH@O}R eFB`HIcA}CuB#Qg Qp Qd#!R_qL@Dqwr_@ !RGYi| !R@AL]ngp',
    ionization: 'ei',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]*+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF`BLGtWdT!eF``fLGtWTH#Qd Qd#!R@AL]Rgp !R@AL]vgp',
    ionization: 'ei',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]*+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFHBLGtWdT!eFH`fLGtWTH#Qd Qd#!R@AL]Rgp !R@AL]vgp',
    ionization: 'ei',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]*+',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFB@HcA}EyE@!eFB`HIcA}EuB#Qd Qd#!R@AL]Rgp !R@AL]vgp',
    ionization: 'ei',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]*+',
  },
  {
    label: 'Inductive cleavage',
    rxnCode: 'eM@jXzB!fH@H eF@bXpP#Q^ Qp QX#!R@AM?DqwrO@ !RG[i| !R_vp]fgp',
    ionization: 'esi',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1002/rcm.9131',
    section: 'conclusion',
    description: 'scheme 1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
    ion: '[M]+',
  },
];
